/* Zen & Zip — cart-page gift wrap upsell.
   Offers two $5 styles ("Holiday Gift Wrapping" / "Zen & Zip Gift Bag")
   as a radio group inserted above the checkout button. Skims-style: an
   easy add-on right where the shopper is about to check out, not forced
   at add-to-cart. Selecting a style adds that variant to the cart;
   switching or picking "No thanks" swaps/removes it. One line item max
   at a time. Product: handle "gift-wrap", unlisted (link/variant-id only,
   never shows in search/collections). Reloads the page after an update
   so cart totals and line items stay authoritative — simpler and more
   reliable than hand-syncing the cart DOM. */
(function () {
  'use strict';

  var HOLIDAY_ID = '67524479844522';
  var GIFT_BAG_ID = '67526878331050';
  var OPTIONS = [
    { id: HOLIDAY_ID, label: 'Holiday Gift Wrapping' },
    { id: GIFT_BAG_ID, label: 'Zen & Zip Gift Bag' }
  ];
  var IDS = OPTIONS.map(function (o) { return o.id; });

  function currentSelection(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var vid = String(cart.items[i].variant_id);
      if (IDS.indexOf(vid) !== -1) return vid;
    }
    return 'none';
  }

  var GIFT_ICON =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<rect x="3" y="9" width="18" height="11" stroke="currentColor" stroke-width="1.6"/>' +
    '<path d="M3 9h18v3.5H3z" fill="currentColor"/>' +
    '<path d="M12 9v11" stroke="var(--zz-cream)" stroke-width="1.4"/>' +
    '<path d="M12 9c-1.8 0-4-1-4-3.2C8 4 9.2 3 10.4 3 12 3 12 6 12 9Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '<path d="M12 9c1.8 0 4-1 4-3.2C16 4 14.8 3 13.6 3 12 3 12 6 12 9Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '</svg>';

  function optionRow(value, label, price, selected) {
    var row = document.createElement('label');
    row.className = 'zz-gift-wrap__option';
    if (value === 'none') row.className += ' zz-gift-wrap__option--none';
    var input = document.createElement('input');
    input.type = 'radio';
    input.name = 'zz-gift-wrap';
    input.value = value;
    if (value === selected) input.checked = true;
    var span = document.createElement('span');
    span.className = 'zz-gift-wrap__option-label';
    span.textContent = label;
    row.appendChild(input);
    row.appendChild(span);
    if (price) {
      var priceEl = document.createElement('span');
      priceEl.className = 'zz-gift-wrap__price';
      priceEl.textContent = price;
      row.appendChild(priceEl);
    }
    return row;
  }

  function buildUI(selected) {
    var wrap = document.createElement('div');
    wrap.className = 'zz-gift-wrap';
    wrap.setAttribute('data-zz-gift-wrap', '');
    wrap.setAttribute('data-zz-selected', selected);

    var head = document.createElement('div');
    head.className = 'zz-gift-wrap__head';
    var icon = document.createElement('span');
    icon.className = 'zz-gift-wrap__icon';
    icon.innerHTML = GIFT_ICON;
    var headText = document.createElement('div');
    var eyebrow = document.createElement('p');
    eyebrow.className = 'zz-gift-wrap__eyebrow';
    eyebrow.textContent = 'Gift wrapping';
    var label = document.createElement('p');
    label.className = 'zz-gift-wrap__label';
    label.textContent = 'Make it a gift for $5';
    headText.appendChild(eyebrow);
    headText.appendChild(label);
    head.appendChild(icon);
    head.appendChild(headText);
    wrap.appendChild(head);

    var group = document.createElement('div');
    group.className = 'zz-gift-wrap__options';
    group.appendChild(optionRow('none', 'No thanks', null, selected));
    OPTIONS.forEach(function (o) {
      group.appendChild(optionRow(o.id, o.label, '$5', selected));
    });
    wrap.appendChild(group);

    wrap.addEventListener('change', onChange);
    return wrap;
  }

  function onChange(e) {
    var input = e.target;
    if (!input || input.type !== 'radio') return;
    var wrap = input.closest('[data-zz-gift-wrap]');
    if (!wrap || wrap.hasAttribute('data-zz-busy')) return;

    var newId = input.value;
    var prevId = wrap.getAttribute('data-zz-selected') || 'none';
    if (newId === prevId) return;

    var updates = {};
    if (prevId !== 'none') updates[prevId] = 0;
    if (newId !== 'none') updates[newId] = 1;

    wrap.setAttribute('data-zz-busy', '');
    Array.prototype.forEach.call(wrap.querySelectorAll('input'), function (i) {
      i.disabled = true;
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart update failed');
        return r.json();
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function () {
        wrap.removeAttribute('data-zz-busy');
        Array.prototype.forEach.call(wrap.querySelectorAll('input'), function (i) {
          i.disabled = false;
        });
        input.checked = false;
        wrap.querySelector('input[value="' + prevId + '"]').checked = true;
      });
  }

  function insertFor(button, selected) {
    var container = button.closest('cart-buttons-block') || button.parentElement;
    if (!container || !container.parentElement) return;
    var prevSibling = container.previousElementSibling;
    if (prevSibling && prevSibling.hasAttribute('data-zz-gift-wrap')) return;
    container.parentElement.insertBefore(buildUI(selected), container);
  }

  function init() {
    var buttons = document.querySelectorAll('[data-cart-page-checkout-button]');
    if (!buttons.length) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.item_count) return;
        var selected = currentSelection(cart);
        Array.prototype.forEach.call(buttons, function (btn) {
          insertFor(btn, selected);
        });
      });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
